import React, { useEffect } from "react";

import Editor from "../../../components/form/Editor";
import Input from "../../../components/form/Input";
import Select from "../../../components/form/Select";
import useForm from "../../../hooks/useForm";
import Button from "../../../components/form/Button";
import useMutation from "../../../hooks/useMutation";
import FileUploadSingle from "../../../components/form/FileUploadSingle";
import DatePicker from "../../../components/form/DatePicker";
import { postAddEdit } from "../../../services/postService";
import { toast } from "react-toastify";

const validation = {
  title: { required: true, message: "Post title is required" },
  publishedAt: { required: true, message: "Published date is required" },
  content: { required: true, message: "Post content is required" },
};

const ManagePost = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        media: data?.media?.[0]?.url || "",
        publishedAt: data?.publishedAt ? new Date(data.publishedAt) : null,
      });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await postAddEdit({
        ...val,
        ...(data?._id && { id: data?._id }),
        publishedAt: val.publishedAt
          ? new Date(val.publishedAt).toISOString()
          : null,
      });
    },
    onSuccess: (res) => {
      // toast.success(
      //   res?.message || data?._id
      //     ? "Post updated successfully!"
      //     : "Post created successfully!"
      // );
      getResponse(res);
      return res;
    },
    onError: (error) => {
      // toast.error(error?.error || "Something went wrong. Please try again.");
      console.log(error);
    },
  });
  // console.log(values, "values");
  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-12">
          <Input
            label="Title"
            inputPlaceholder={"Enter Tittle"}
            inputName="title"
            value={values?.title}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        {/* <div className="relative col-span-4">
          <Select
            label={"Category"}
            placeholder="Select category"
            selectedValue={values?.categoryId}
            dropdownData={
              [
                // { name: "Active", value: 1 },
                // { name: "InActive", value: 2 },
              ]
            }
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "categoryId", value: val },
              });
            }}
          />
        </div> */}
        <div className="relative col-span-12">
          <Editor
            label="Post Content"
            placeholder="Content"
            value={values?.content}
            onChange={(val) =>
              handleChange({ target: { name: "content", value: val } })
            }
            {...formValidate(errors, "content")}
          />
        </div>
        <div className="relative col-span-6">
          <FileUploadSingle
            size="small"
            label={"Upload Media"}
            value={values?.media}
            onChange={(file) =>
              handleChange({ target: { name: "media", value: file } })
            }
            {...formValidate(errors, "media")}
            accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.tiff,.svg,image/*"
          />
        </div>
        <div className="relative col-span-3">
          <Select
            label={"Featured (yes/no)"}
            placeholder="Select featured"
            selectedValue={values?.featured}
            dropdownData={[
              { name: "Yes", value: 1 },
              { name: "No", value: 2 },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "featured", value: val },
              });
            }}
          />
        </div>
        <div className="relative col-span-3">
          <DatePicker
            label={"Published Date"}
            value={{
              startDate: values?.publishedAt,
              endDate: values?.publishedAt,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "publishedAt" },
              });
            }}
            {...formValidate(errors, "publishedAt")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManagePost;
